import { gql } from '@apollo/client'

export const CREATE_PLACE = gql`
  mutation CreatePlaceV2($input: CreatePlaceV2Input!) {
    createPlaceV2(input: $input)
  }
`

export const CHANGE_PLACE = gql`
  mutation ChangePlaceV2($id: UUID!, $input: ChangePlaceV2Input!) {
    changePlaceV2(id: $id, input: $input)
  }
`
